import React, { useState } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';

import Row from '../../tag/Row';
import Span from '../../tag/Span';
import OTButtonGroup from '../../tag/OTButtonGroup';
import OTButton from '../../tag/OTButton';

import ServiceCard from '../ServiceCard';
import { SULJETTU, PYYDETTY } from '../../../definitions/LibreViewConstants';
import WindowUtils from '../../../utils/WindowUtils';
import { doRedirect } from '../../../data/service/libreview/actions';
import Alert from '../../Alert';
import LibreviewContinueModal from './LibreviewContinueModal';

import freestyleLibreLogo from '../../../images/freestyle-libre-logo.png';

const { id: module_id } = module;

const LibreviewServiceCard = (props) => {
  const { libreview, integrations, doRedirect } = props;

  const [urlError, setUrlError] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [showInitializationAlert, setShowInitializationAlert] = useState(false);

  const libreviewObject = _.find(integrations.data, { name: 'Libreview' });

  const handleOnClick = () => {
    doRedirect().then((url) => {
      if (url !== null && url !== '') {
        setOpenDialog(true);
      } else {
        setUrlError(true);
      }
    });
  };

  const modalCancel = () => {
    setOpenDialog(false);
  };

  const redirectToLibreView = () => {
    WindowUtils.openInNewTab(decodeURIComponent(libreview.url.url));
    setShowInitializationAlert(true);
  };

  // if no integration found, render nothing.
  if (!libreviewObject) return null;

  return (
    <>
      <Row>
        <Span len={12}>
          <FormattedMessage id={`${module_id}.libreview.header`}>
            {(txt) => <h2>{txt}</h2>}
          </FormattedMessage>
          {urlError && <Alert message={`default.error.message`} />}

            {showInitializationAlert &&
                <Alert type="info" className={'libreview-alert-info'}>
                    <FormattedMessage
                        id={`${module.id}.libreview.alert.info`}
                        values={{
                            br: <br/>
                        }}>
                        {txt => txt}
                    </FormattedMessage>
                </Alert>
            }
          <ServiceCard
            disabled={libreviewObject.status === SULJETTU}
            message={
              <FormattedMessage
                  id={`libreview.status.${libreviewObject.status}.desc`}
                  values= {{
                    br: <br/>
                  }}
              >
                { txt => txt }
              </FormattedMessage>}
            name={`${module_id}.libreview.title`}
            isNameHidden={true}
            enabledlogoSrc={freestyleLibreLogo}
            disabledLogoSrc={freestyleLibreLogo}
          >
            {libreviewObject.status === PYYDETTY && (
              <OTButtonGroup type={'big'}>
                <OTButton onClick={handleOnClick}>
                  <FormattedMessage id={`${module_id}.go.to.service`} />
                </OTButton>
              </OTButtonGroup>
            )}
          </ServiceCard>
        </Span>
      </Row>
      <LibreviewContinueModal
        isOpen={openDialog}
        closeModal={modalCancel}
        redirectToLibreView={redirectToLibreView}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    integrations: state.services.integrations,
    libreview: state.services.libreview,
  };
};

export default
  connect(mapStateToProps, { doRedirect })(withRouter(LibreviewServiceCard));
